import '../css/style.scss';

import './burger-menu'
import './sliders'